@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  @include typography-v2-title-md;
}

.buttonGroup {
  @include border-radius-r3;
  border: 1px solid var(--border-soft);
  background-color: var(--background-soft);
  width: 300px;

  [data-button-group-item] {
    @include border-radius-r2;
    padding: 6px 8px;
  }
}
